module.exports = __webpack_public_path__ + "img/jinghui.b7cd7e83.png";